module.exports = __webpack_public_path__ + "static/img/sensor_optico_tcrt5000-1.8303ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensor_optico_tcrt5000-1.svg
// module id = Nnpj
// module chunks = 0